import type { CaseRecord, ConversationEntry, CorrectionRecord, PersonRecord, RelationRecord, SourceRecord, StatementRecord } from '../types'
import { caseSchema, conversationEntrySchema, correctionSchema, relationSchema, sourceSchema, statementSchema } from './schemas'
import sourcesData from './sources/core.json'
import judicialSources from './sources/judicial-2026.json'
import { republicaCase, republicaSources } from './investigations/republica'
import { jairCaseRecords, jairClaims } from './jair/cases'
import { jairSources } from './jair/sources'
import { jairMedia } from './jair/media'
import { jairComparisons, jairComparisonCaseIds } from './jair/comparisons'
export { jairClaims, jairMedia }
import punhalCase from './cases/bolsonaro-mandou-matar-lula-punhal-verde-amarelo.json'
import anaClaraCase from './cases/caso-ana-clara-flavio-bolsonaro.json'
import peopleData from './people/core.json'
import correctionsData from './corrections/core.json'
import judicialCorrections from './corrections/judicial-2026.json'
import relationsData from './relations/core.json'
import judicialRelations from './relations/judicial-2026.json'
import caseEnrichmentData from './case-enrichment.json'
import statementData from './statements/negativa-pedido-desculpas.json'
import intimacyStatement from './statements/intimidade-vorcaro.json'
import masterStatement from './statements/master-longe-direita.json'
import scaleStatement from './statements/escala-6x1.json'
import votingStatement from './statements/urnas-eletronicas.json'
import constitutionStatement from './statements/constituicao.json'
import democracyStatement from './statements/ditadura-democracia.json'
import darkHorseConversationData from './conversations/dark-horse.json'
import darkHorse from './cases/dark-horse.json'
import jatoWiller from './cases/jato-willer.json'
import rachadinha from './cases/rachadinha.json'
import kopenhagen from './cases/kopenhagen.json'
import patrimonio from './cases/patrimonio.json'
import adriano from './cases/adriano.json'
import abin from './cases/abin.json'
import iaEleitoral from './cases/ia-eleitoral.json'
import cpiPandemia from './cases/cpi-pandemia.json'
import escala6x1 from './cases/escala-6x1.json'
import willerInss from './cases/willer-inss.json'
import urnas from './cases/urnas.json'
import caluniaLula from './cases/calunia-lula.json'
import ditaduraUstra from './cases/ditadura-ustra-carandiru.json'
import constituicaoEstadoLaico from './cases/constituicao-estado-laico.json'
import cotasRaciais from './cases/cotas-raciais.json'
import estadoMenor from './cases/estado-menor-para-quem.json'
import meioAmbiente from './cases/flexibilizar-agora-pagar-depois.json'
import povosIndigenas from './cases/povos-indigenas-autonomia-exploracao.json'
import lgbtqia from './cases/lgbtqia-plano-e-discurso.json'
import brasilTrump from './cases/brasil-na-mesa-de-trump.json'
import elytron from './cases/elytron-operacao-eleitoral.json'
import pixSoberania from './cases/pix-soberania.json'
import entrevistaGlobo from './cases/entrevista-globo-16-outubro.json'
import ceapsDuplicates from './cases/ceaps-duplicidades.json'
import debateBand from './cases/debate-band-18-outubro.json'

export const sources = ([...sourcesData, ...judicialSources, ...republicaSources, ...jairSources] as unknown[]).map((item) => sourceSchema.parse(item)) as SourceRecord[]
const caseEnrichment = caseEnrichmentData as Record<string, Partial<CaseRecord>>
const rawCases = [debateBand, ceapsDuplicates, entrevistaGlobo, darkHorse, pixSoberania, elytron, estadoMenor, meioAmbiente, povosIndigenas, lgbtqia, brasilTrump, ditaduraUstra, constituicaoEstadoLaico, cotasRaciais, jatoWiller, willerInss, rachadinha, kopenhagen, patrimonio, adriano, abin, iaEleitoral, urnas, caluniaLula, cpiPandemia, escala6x1]
const documentaryCases = jairCaseRecords.map(record => {
  const comparisons = jairComparisons.filter(item => jairComparisonCaseIds.get(item.id) === record.id)
  return { ...record, sources: [...new Set([...record.sources, ...comparisons.flatMap(item => item.sourceIds)])], statementIds: comparisons.map(item => item.id), documentary: { ...record.documentary!, mediaIds: jairMedia.filter(item => item.caseId === record.id).map(item => item.id) } }
})
export const cases = [republicaCase, punhalCase, anaClaraCase, ...rawCases, ...documentaryCases].map((item) => caseSchema.parse({ ...item, ...caseEnrichment[item.slug] })) as CaseRecord[]
export const statements = [statementData, intimacyStatement, masterStatement, scaleStatement, votingStatement, constitutionStatement, democracyStatement, ...jairComparisons].map((item) => statementSchema.parse(item)) as StatementRecord[]
export const darkHorseConversation = (darkHorseConversationData as unknown[]).map((item) => conversationEntrySchema.parse(item)) as ConversationEntry[]
export const corrections = ([...correctionsData, ...judicialCorrections] as unknown[]).map((item) => correctionSchema.parse(item)) as CorrectionRecord[]
export const relations = ([...relationsData, ...judicialRelations] as unknown[]).map((item) => relationSchema.parse(item)) as RelationRecord[]
export const people = peopleData as PersonRecord[]
export const sourceById = new Map(sources.map((source) => [source.id, source]))
export const caseBySlug = new Map(cases.map((record) => [record.slug, record]))
export const personById = new Map(people.map((person) => [person.id, person]))

export const allTimeline = cases
  .flatMap((record) => record.timeline.map((event) => ({ ...event, caseId: record.id, caseSlug: record.slug, casePath: record.investigation?.route ?? `/casos/${record.slug}`, caseTitle: record.shortTitle, category: record.category })))
  .sort((a, b) => b.date.localeCompare(a.date))
